// extracted by mini-css-extract-plugin
module.exports = {"default":"borrowMore_default__MKuxh","hide":"borrowMore_hide__eq643"};